import React from "react";
import { shallowEqual } from "react-redux";
import { useUscLabel } from "../../../../utils/labels";
import { useUscDispatch, useUscSelector } from "../../../../redux/store";
import UscInsurancePanel from "../basket/UscInsurancePanel";
import useUscInsuranceCalculatorButton from "../../../../hooks/uscUscInsuranceCalculatorButton";
import { trackBasketRemoveItem, trackCta, uscStepTrackingLocationMap } from "../../../../utils/tracking";
import ServicesCard, { ServicesCardDetails } from "../../styles/molecules/ServicesCard";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import { setInsuranceQuote } from "../../../../redux/actions/UscInsuranceActions";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import { getAemInsuranceRateFormat } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { formatUscInsurancePriceAsObject } from "../../../../utils/insuranceUtils";
import { useComponentRegistry } from "../../componentRegistry";

const InsuranceService = (): JSX.Element => {
    const dispatch = useUscDispatch();
    const insurancePriceFormat = useUscSelector(({ commonSettings, vehicle }) =>
        getAemInsuranceRateFormat(commonSettings, AemFmComponent.Pdp, vehicle.type),
    );
    const vehicle = useUscSelector((state) => state.vehicle);
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const insuranceIsActive = useUscSelector((state) => !!state.insurance.quote);
    const step = useUscSelector((state) => state.nav.step);
    const trackingLocation = uscStepTrackingLocationMap[step];

    const { price: insurancePrice } = useUscSelector(
        ({ insurance, commonSettings, uscSettings }) =>
            formatUscInsurancePriceAsObject(commonSettings, uscSettings, insurance.quote, insurancePriceFormat),
        shallowEqual,
    );

    const [
        editDetailsLabel,
        showDetailsLabel,
        serviceInsuranceTitleLabel,
        basketTitleInsurance,
        insuranceDescriptionLabel,
    ] = useUscLabel([
        "uscServicesInsuranceEditDetails",
        "uscServicesInsuranceShowDetails",
        "uscServicesInsuranceTitle",
        "uscBasketTitleInsurance",
        "uscBasketInsuranceDescription",
    ]);

    const { showInsuranceCalculator } = useUscInsuranceCalculatorButton();

    const ServicesCardFooter = useComponentRegistry("ServicesCardFooter");

    return (
        <ServicesCard
            icon="insurance"
            title={serviceInsuranceTitleLabel}
            descriptionLabel={insuranceDescriptionLabel}
            hideOptionalIncluded
            isActive={insuranceIsActive}
            role="option"
        >
            <ServicesCardDetails
                title={basketTitleInsurance}
                active={insuranceIsActive}
                removeService={() => {
                    trackBasketRemoveItem(trackingLocation, vehicleType, "insurance");
                    dispatch(setInsuranceQuote(null));
                }}
            >
                <UscInsurancePanel />
            </ServicesCardDetails>
            <ServicesCardFooter>
                <div>
                    <Text tag="span" variant="body-semibold">
                        {insurancePrice}
                    </Text>
                </div>
                <Button
                    variant="pack"
                    onClick={() => {
                        trackCta("insurance-calculator", trackingLocation, vehicle.type);
                        showInsuranceCalculator();
                    }}
                >
                    {insuranceIsActive ? editDetailsLabel : showDetailsLabel}
                </Button>
            </ServicesCardFooter>
        </ServicesCard>
    );
};

export default InsuranceService;
